import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function DnDMoveSidebarSettingsImage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else DnDMoveSidebarSettingsImage_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const DnDMoveSidebarSettingsImage = (props)=>{
    const $ = c(37);
    let t0;
    let t1;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t2;
    let t20;
    let t21;
    let t22;
    let t23;
    let t24;
    let t25;
    let t26;
    let t27;
    let t28;
    let t29;
    let t3;
    let t30;
    let t31;
    let t32;
    let t33;
    let t34;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx("path", {
            d: "M31.8715 82.2404C32.2054 82.2949 32.5486 82.3232 32.8992 82.3232V83.2196L32.7135 83.2172C32.3779 83.2088 32.0482 83.1766 31.7256 83.1239L31.8715 82.2404ZM34.2193 82.3232V83.2196H32.8992V82.3232H34.2193ZM38.4445 82.3232V83.2196H35.8037V82.3232H38.4445ZM42.6691 82.3232V83.2196H40.0289V82.3232H42.6691ZM46.8938 82.3232V83.2196H44.2535V82.3232H46.8938ZM51.1189 82.3232V83.2196H48.4781V82.3232H51.1189ZM55.3436 82.3232V83.2196H52.7033V82.3232H55.3436ZM59.5688 82.3232V83.2196H56.9279V82.3232H59.5688ZM63.7934 82.3232V83.2196H61.1531V82.3232H63.7934ZM68.0186 82.3232V83.2196H65.3777V82.3232H68.0186ZM72.2432 82.3232V83.2196H69.6023V82.3232H72.2432ZM76.4678 82.3232V83.2196H73.8275V82.3232H76.4678ZM79.3723 82.3232V83.2196H78.0522V82.3232H79.3723ZM80.5453 83.1239C80.2231 83.1765 79.8937 83.2088 79.5586 83.2172L79.3723 83.2196V82.3232C79.7229 82.3232 80.0667 82.2949 80.4006 82.2404L80.5453 83.1239ZM83.9397 81.5914C83.3368 82.0847 82.652 82.4816 81.9088 82.7603L81.5924 81.9229C82.242 81.6793 82.841 81.3313 83.3689 80.8994L83.9397 81.5914ZM28.9031 80.8994C29.431 81.3313 30.0302 81.6793 30.6797 81.9229L30.4658 82.4872L30.3621 82.7597C29.619 82.4809 28.934 82.0847 28.3313 81.5914L28.9031 80.8994ZM27.0012 78.2593C27.2458 78.9063 27.5952 79.5029 28.0289 80.0287L27.6803 80.3129L27.6809 80.3135L27.3334 80.5971C26.8382 79.9967 26.4396 79.3147 26.1598 78.5745L27.0012 78.2593ZM86.1117 78.5745C85.8319 79.3147 85.4334 79.9967 84.9381 80.5971L84.5906 80.3135L84.2432 80.0287C84.6769 79.503 85.0263 78.9062 85.2709 78.2593L86.1117 78.5745ZM25.6992 76.0488V74.7954H26.5992V76.0488C26.5992 76.398 26.6277 76.7399 26.6824 77.0724L25.7947 77.2165C25.7419 76.8956 25.7101 76.5676 25.7016 76.2338L25.6992 76.0488ZM86.5699 76.2338C86.5614 76.5676 86.5295 76.8956 86.4768 77.2165L85.5891 77.0724C85.6438 76.7399 85.6728 76.398 85.6729 76.0488V74.7954H86.5729V76.0488L86.5699 76.2338ZM26.5992 70.7846V73.291H25.6992V70.7846H26.5992ZM86.5729 70.7846V73.291H85.6729V70.7846H86.5729ZM26.5992 66.7738V69.2802H25.6992V66.7738H26.5992ZM86.5729 66.7738V69.2802H85.6729V66.7738H86.5729ZM26.5992 62.7624V65.2694H25.6992V62.7624H26.5992ZM86.5729 62.7624V65.2694H85.6729V62.7624H86.5729ZM26.5992 58.7517V61.2586H25.6992V58.7517H26.5992ZM86.5729 58.7517V61.2586H85.6729V58.7517H86.5729ZM26.5992 54.7409V57.2478H25.6992V54.7409H26.5992ZM86.5729 54.7409V57.2478H85.6729V54.7409H86.5729ZM26.5992 50.7301V53.2371H25.6992V50.7301H26.5992ZM86.5729 50.7301V53.2371H85.6729V50.7301H86.5729ZM26.5992 46.7193V49.2263H25.6992V46.7193H26.5992ZM86.5729 46.7193V49.2263H85.6729V46.7193H86.5729ZM86.5729 42.7085V45.2155H85.6729V42.7085H86.5729ZM26.5992 42.7085V45.2149H25.6992V42.7085H26.5992ZM26.5992 38.6978V41.2041H25.6992V38.6978H26.5992ZM86.5729 38.6978V41.2041H85.6729V38.6978H86.5729ZM26.5992 34.687V37.1934H25.6992V34.687H26.5992ZM86.5729 34.687V37.1934H85.6729V34.687H86.5729ZM26.5992 30.6756V33.1826H25.6992V30.6756H26.5992ZM86.5729 30.6756V33.1826H85.6729V30.6756H86.5729ZM26.5992 26.6649V29.1718H25.6992V26.6649H26.5992ZM86.5729 26.6649V29.1718H85.6729V26.6649H86.5729ZM25.6992 23.9075C25.6992 23.5095 25.7321 23.1191 25.7947 22.7387L26.6824 22.884C26.6277 23.2165 26.5992 23.5584 26.5992 23.9075V25.161H25.6992V23.9075ZM86.5729 25.161H85.6729V23.9075C85.6729 23.5584 85.6438 23.2165 85.5891 22.884L86.4768 22.7387C86.5394 23.1191 86.5729 23.5095 86.5729 23.9075V25.161ZM28.0289 19.9277C27.5952 20.4534 27.2458 21.0501 27.0012 21.697L26.5799 21.5383L26.1604 21.3808C26.4402 20.6407 26.8382 19.9584 27.3334 19.3581L28.0289 19.9277ZM84.9381 19.3581C85.4333 19.9584 85.8312 20.6407 86.1111 21.3808L85.2709 21.697C85.0263 21.0502 84.6768 20.4534 84.2432 19.9277L84.9381 19.3581ZM30.6797 18.0335C30.0301 18.2771 29.431 18.6251 28.9031 19.057L28.3313 18.3644C28.934 17.8711 29.6191 17.4748 30.3621 17.1961L30.6797 18.0335ZM81.9088 17.1955C82.652 17.4742 83.3368 17.8711 83.9397 18.3644L83.3689 19.057C82.8411 18.6251 82.242 18.2771 81.5924 18.0335L81.9088 17.1955ZM34.2193 16.7368V17.6332H32.8992C32.5486 17.6332 32.2054 17.6615 31.8715 17.716L31.7256 16.8319C32.1075 16.7696 32.4995 16.7368 32.8992 16.7368H34.2193ZM79.3723 16.7368C79.7716 16.7368 80.1636 16.7697 80.5453 16.8319L80.4006 17.716C80.0667 17.6615 79.7229 17.6332 79.3723 17.6332H78.0522V16.7368H79.3723ZM38.4445 16.7368V17.6332H35.8037V16.7368H38.4445ZM42.6691 16.7368V17.6332H40.0289V16.7368H42.6691ZM46.8938 16.7368V17.6332H44.2535V16.7368H46.8938ZM51.1189 16.7368V17.6332H48.4781V16.7368H51.1189ZM55.3436 16.7368V17.6332H52.7033V16.7368H55.3436ZM59.5688 16.7368V17.6332H56.9279V16.7368H59.5688ZM63.7934 16.7368V17.6332H61.1531V16.7368H63.7934ZM68.0186 16.7368V17.6332H65.3777V16.7368H68.0186ZM72.2432 16.7368V17.6332H69.6023V16.7368H72.2432ZM76.4678 16.7368V17.6332H73.8275V16.7368H76.4678Z",
            fill: "#E2E6EB"
        });
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M32.0069 45.8364C32.0069 44.509 33.0873 43.433 34.4201 43.433H78.3491C79.6819 43.433 80.7623 44.509 80.7623 45.8363V55.132C80.7623 56.4593 79.6819 57.5353 78.3491 57.5353H34.4201C33.0873 57.5353 32.0069 56.4593 32.0069 55.132V45.8364Z",
            fill: "white"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M80.7623 55.132C80.7623 56.4593 79.6819 57.5353 78.3491 57.5353H34.4201C33.0873 57.5353 32.0069 56.4593 32.0069 55.132L32.0098 55.2348C32.0743 56.2931 33.1292 57.1349 34.4204 57.1349H78.3493C79.6819 57.1348 80.7622 56.238 80.7623 55.132Z",
            fill: "#E2E6EB"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M32.0069 45.8364C32.0069 44.509 33.0873 43.433 34.4201 43.433H78.3491C79.6819 43.433 80.7623 44.509 80.7623 45.8363V55.132C80.7623 56.4593 79.6819 57.5353 78.3491 57.5353H34.4201C33.0873 57.5353 32.0069 56.4593 32.0069 55.132V45.8364Z",
            fill: "#FAFAFA"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M80.7623 55.132C80.7623 56.4593 79.6819 57.5353 78.3491 57.5353H34.4201C33.0873 57.5353 32.0069 56.4593 32.0069 55.132L32.0098 55.2348C32.0743 56.2931 33.1292 57.1349 34.4204 57.1349H78.3493C79.6819 57.1348 80.7622 56.238 80.7623 55.132Z",
            fill: "#E2E6EB"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M32.0068 65.8795C32.0068 64.5521 33.0873 63.4761 34.42 63.4761H78.349C79.6818 63.4761 80.7622 64.5521 80.7622 65.8795V75.1751C80.7622 76.5024 79.6818 77.5784 78.349 77.5784H34.42C33.0873 77.5784 32.0068 76.5024 32.0068 75.1751V65.8795Z",
            fill: "white"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M80.7622 75.1751C80.7622 76.5024 79.6818 77.5784 78.349 77.5784H34.42C33.0873 77.5784 32.0068 76.5024 32.0068 75.1751L32.0098 75.2779C32.0743 76.3362 33.1291 77.178 34.4203 77.178H78.3492C79.6819 77.1779 80.7621 76.2811 80.7622 75.1751Z",
            fill: "#E2E6EB"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M32.0068 65.8795C32.0068 64.5521 33.0873 63.4761 34.42 63.4761H78.349C79.6818 63.4761 80.7622 64.5521 80.7622 65.8795V75.1751C80.7622 76.5024 79.6818 77.5784 78.349 77.5784H34.42C33.0873 77.5784 32.0068 76.5024 32.0068 75.1751V65.8795Z",
            fill: "white"
        });
        t8 = /*#__PURE__*/ jsx("path", {
            d: "M80.7622 75.1751C80.7622 76.5024 79.6818 77.5784 78.349 77.5784H34.42C33.0873 77.5784 32.0068 76.5024 32.0068 75.1751L32.0098 75.2779C32.0743 76.3362 33.1291 77.178 34.4203 77.178H78.3492C79.6819 77.1779 80.7621 76.2811 80.7622 75.1751Z",
            fill: "#E2E6EB"
        });
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M48.2585 67.2995C48.2585 66.8571 48.6186 66.4984 49.0629 66.4984H70.2066C70.6509 66.4984 71.011 66.8571 71.011 67.2995V67.7119C71.011 68.1544 70.6509 68.513 70.2066 68.513H49.0629C48.6186 68.513 48.2585 68.1544 48.2585 67.7119V67.2995Z",
            fill: "#E2E6EB"
        });
        t10 = /*#__PURE__*/ jsx("path", {
            d: "M71.011 67.7119C71.011 68.1544 70.6509 68.513 70.2066 68.513H49.0629C48.6186 68.513 48.2585 68.1544 48.2585 67.7119C48.2585 68.0437 48.6187 68.3127 49.063 68.3127H70.2065C70.6508 68.3127 71.011 68.0437 71.011 67.7119Z",
            fill: "#818C99"
        });
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M48.2585 71.3287C48.2585 70.8863 48.6186 70.5276 49.0629 70.5276H59.3721C59.8163 70.5276 60.1765 70.8863 60.1765 71.3287V71.7411C60.1765 72.1836 59.8163 72.5422 59.3721 72.5422H49.0629C48.6186 72.5422 48.2585 72.1836 48.2585 71.7411V71.3287Z",
            fill: "#E2E6EB"
        });
        t12 = /*#__PURE__*/ jsx("path", {
            d: "M60.1765 71.7411C60.1765 72.1836 59.8163 72.5422 59.3721 72.5422H49.0629C48.6186 72.5422 48.2585 72.1836 48.2585 71.7411C48.2585 72.0729 48.6187 72.3419 49.063 72.3419H59.372C59.8162 72.3419 60.1765 72.0729 60.1765 71.7411Z",
            fill: "#818C99"
        });
        t13 = /*#__PURE__*/ jsx("path", {
            d: "M34.1738 67.0199C34.1738 66.135 34.8941 65.4176 35.7826 65.4176H42.765C43.6535 65.4176 44.3738 66.135 44.3738 67.0199V73.9739C44.3738 74.8588 43.6535 75.5761 42.765 75.5761H35.7826C34.8941 75.5761 34.1738 74.8588 34.1738 73.9739V67.0199Z",
            fill: "#D8E5FF"
        });
        t14 = /*#__PURE__*/ jsx("path", {
            d: "M44.3738 73.9739C44.3738 74.8588 43.6535 75.5761 42.765 75.5761H35.7826C34.8941 75.5761 34.1738 74.8588 34.1738 73.9739C34.1738 74.641 34.8943 75.1817 35.7828 75.1817H42.7648C43.6533 75.1817 44.3738 74.641 44.3738 73.9739Z",
            fill: "#99BCFF"
        });
        t15 = /*#__PURE__*/ jsx("path", {
            d: "M47.3855 39.69C47.5261 38.3701 48.7145 37.4136 50.0398 37.5537L93.7236 42.1707C95.0489 42.3107 96.0092 43.4943 95.8686 44.8143L94.8836 54.058C94.743 55.3779 93.5546 56.3344 92.2293 56.1943L48.5455 51.5773C47.2202 51.4372 46.2598 50.2536 46.4005 48.9337L47.3855 39.69Z",
            fill: "white"
        });
        t16 = /*#__PURE__*/ jsx("path", {
            d: "M94.8836 54.058C94.743 55.3779 93.5546 56.3344 92.2293 56.1943L48.5455 51.5773C47.2202 51.4372 46.2598 50.2536 46.4005 48.9337L46.3925 49.0363C46.3445 50.0955 47.3042 51.0434 48.5882 51.1791L92.2719 55.7961C93.5971 55.936 94.7663 55.1578 94.8836 54.058Z",
            fill: "#E2E6EB"
        });
        t17 = /*#__PURE__*/ jsx("path", {
            d: "M47.3855 39.69C47.5261 38.3701 48.7145 37.4136 50.0398 37.5537L93.7236 42.1707C95.0489 42.3107 96.0092 43.4943 95.8686 44.8143L94.8836 54.058C94.743 55.3779 93.5546 56.3344 92.2293 56.1943L48.5455 51.5773C47.2202 51.4372 46.2598 50.2536 46.4005 48.9337L47.3855 39.69Z",
            fill: "white"
        });
        t18 = /*#__PURE__*/ jsx("path", {
            d: "M94.8836 54.058C94.743 55.3779 93.5546 56.3344 92.2293 56.1943L48.5455 51.5773C47.2202 51.4372 46.2598 50.2536 46.4005 48.9337L46.3925 49.0363C46.3445 50.0955 47.3042 51.0434 48.5882 51.1791L92.2719 55.7961C93.5971 55.936 94.7663 55.1578 94.8836 54.058Z",
            fill: "#E2E6EB"
        });
        t19 = /*#__PURE__*/ jsx("path", {
            d: "M63.3959 42.8102C63.4428 42.3702 63.8389 42.0514 64.2807 42.0981L85.3063 44.3203C85.7481 44.367 86.0682 44.7616 86.0214 45.2015L85.9777 45.6116C85.9308 46.0516 85.5346 46.3704 85.0929 46.3237L64.0672 44.1015C63.6254 44.0548 63.3053 43.6603 63.3522 43.2203L63.3959 42.8102Z",
            fill: "#E2E6EB"
        });
        t20 = /*#__PURE__*/ jsx("path", {
            d: "M85.9777 45.6116C85.9308 46.0516 85.5346 46.3704 85.0929 46.3237L64.0672 44.1015C63.6254 44.0548 63.3053 43.6603 63.3522 43.2203C63.317 43.5503 63.6468 43.8556 64.0885 43.9023L85.114 46.1245C85.5558 46.1712 85.9425 45.9416 85.9777 45.6116Z",
            fill: "#818C99"
        });
        t21 = /*#__PURE__*/ jsx("path", {
            d: "M62.9689 46.8169C63.0158 46.3769 63.412 46.0581 63.8537 46.1048L74.1054 47.1883C74.5471 47.235 74.8673 47.6295 74.8204 48.0695L74.7767 48.4796C74.7298 48.9196 74.3337 49.2384 73.8919 49.1917L63.6403 48.1082C63.1985 48.0615 62.8784 47.667 62.9252 47.227L62.9689 46.8169Z",
            fill: "#E2E6EB"
        });
        t22 = /*#__PURE__*/ jsx("path", {
            d: "M74.7767 48.4796C74.7298 48.9196 74.3337 49.2384 73.8919 49.1917L63.6403 48.1082C63.1985 48.0615 62.8784 47.667 62.9252 47.227C62.8901 47.557 63.2198 47.8623 63.6616 47.909L73.913 48.9925C74.3548 49.0392 74.7415 48.8096 74.7767 48.4796Z",
            fill: "#818C99"
        });
        t23 = /*#__PURE__*/ jsx("path", {
            d: "M49.4195 41.0518C49.5132 40.1718 50.3055 39.5342 51.189 39.6276L58.1325 40.3614C59.016 40.4548 59.6563 41.2439 59.5625 42.1238L58.8256 49.039C58.7319 49.919 57.9396 50.5566 57.0561 50.4632L50.1126 49.7294C49.2291 49.636 48.5888 48.8469 48.6826 47.967L49.4195 41.0518Z",
            fill: "#D8E5FF"
        });
        t24 = /*#__PURE__*/ jsx("path", {
            d: "M58.8256 49.039C58.7319 49.919 57.9396 50.5566 57.0561 50.4632L50.1126 49.7294C49.2291 49.636 48.5888 48.8469 48.6826 47.967C48.6119 48.6303 49.2711 49.2437 50.1546 49.3371L57.0977 50.0709C57.9812 50.1643 58.755 49.7024 58.8256 49.039Z",
            fill: "#99BCFF"
        });
        t25 = /*#__PURE__*/ jsx("path", {
            d: "M32.0068 24.0502C32.0068 22.7228 33.0873 21.6468 34.42 21.6468H78.349C79.6818 21.6468 80.7622 22.7228 80.7622 24.0502V33.3458C80.7622 34.6731 79.6818 35.7492 78.349 35.7492H34.42C33.0873 35.7492 32.0068 34.6731 32.0068 33.3458V24.0502Z",
            fill: "white"
        });
        t26 = /*#__PURE__*/ jsx("path", {
            d: "M80.7622 33.3458C80.7622 34.6731 79.6818 35.7492 78.349 35.7492H34.42C33.0873 35.7492 32.0068 34.6731 32.0068 33.3458L32.0098 33.4486C32.0743 34.507 33.1291 35.3487 34.4203 35.3487H78.3492C79.6819 35.3486 80.7621 34.4518 80.7622 33.3458Z",
            fill: "#E2E6EB"
        });
        t27 = /*#__PURE__*/ jsx("path", {
            d: "M32.0068 24.0502C32.0068 22.7228 33.0873 21.6468 34.42 21.6468H78.349C79.6818 21.6468 80.7622 22.7228 80.7622 24.0502V33.3458C80.7622 34.6731 79.6818 35.7492 78.349 35.7492H34.42C33.0873 35.7492 32.0068 34.6731 32.0068 33.3458V24.0502Z",
            fill: "white"
        });
        t28 = /*#__PURE__*/ jsx("path", {
            d: "M80.7622 33.3458C80.7622 34.6731 79.6818 35.7492 78.349 35.7492H34.42C33.0873 35.7492 32.0068 34.6731 32.0068 33.3458L32.0098 33.4486C32.0743 34.507 33.1291 35.3487 34.4203 35.3487H78.3492C79.6819 35.3486 80.7621 34.4518 80.7622 33.3458Z",
            fill: "#E2E6EB"
        });
        t29 = /*#__PURE__*/ jsx("path", {
            d: "M48.2585 25.4703C48.2585 25.0278 48.6186 24.6691 49.0629 24.6691H70.2066C70.6509 24.6691 71.011 25.0278 71.011 25.4703V25.8826C71.011 26.3251 70.6509 26.6838 70.2066 26.6838H49.0629C48.6186 26.6838 48.2585 26.3251 48.2585 25.8826V25.4703Z",
            fill: "#E2E6EB"
        });
        t30 = /*#__PURE__*/ jsx("path", {
            d: "M71.011 25.8826C71.011 26.3251 70.6509 26.6838 70.2066 26.6838H49.0629C48.6186 26.6838 48.2585 26.3251 48.2585 25.8826C48.2585 26.2145 48.6187 26.4834 49.063 26.4834H70.2065C70.6508 26.4834 71.011 26.2145 71.011 25.8826Z",
            fill: "#818C99"
        });
        t31 = /*#__PURE__*/ jsx("path", {
            d: "M48.2585 29.4995C48.2585 29.057 48.6186 28.6983 49.0629 28.6983H59.3721C59.8163 28.6983 60.1765 29.057 60.1765 29.4995V29.9118C60.1765 30.3543 59.8163 30.713 59.3721 30.713H49.0629C48.6186 30.713 48.2585 30.3543 48.2585 29.9118V29.4995Z",
            fill: "#E2E6EB"
        });
        t32 = /*#__PURE__*/ jsx("path", {
            d: "M60.1765 29.9118C60.1765 30.3543 59.8163 30.713 59.3721 30.713H49.0629C48.6186 30.713 48.2585 30.3543 48.2585 29.9118C48.2585 30.2437 48.6187 30.5126 49.063 30.5126H59.372C59.8162 30.5126 60.1765 30.2437 60.1765 29.9118Z",
            fill: "#818C99"
        });
        t33 = /*#__PURE__*/ jsx("path", {
            d: "M34.1738 25.1906C34.1738 24.3057 34.8941 23.5883 35.7826 23.5883H42.765C43.6535 23.5883 44.3738 24.3057 44.3738 25.1906V32.1446C44.3738 33.0295 43.6535 33.7469 42.765 33.7469H35.7826C34.8941 33.7469 34.1738 33.0295 34.1738 32.1446V25.1906Z",
            fill: "#D8E5FF"
        });
        t34 = /*#__PURE__*/ jsx("path", {
            d: "M44.3738 32.1446C44.3738 33.0295 43.6535 33.7469 42.765 33.7469H35.7826C34.8941 33.7469 34.1738 33.0295 34.1738 32.1446C34.1738 32.8117 34.8943 33.3524 35.7828 33.3524H42.7648C43.6533 33.3524 44.3738 32.8117 44.3738 32.1446Z",
            fill: "#99BCFF"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t10;
        $[3] = t11;
        $[4] = t12;
        $[5] = t13;
        $[6] = t14;
        $[7] = t15;
        $[8] = t16;
        $[9] = t17;
        $[10] = t18;
        $[11] = t19;
        $[12] = t2;
        $[13] = t20;
        $[14] = t21;
        $[15] = t22;
        $[16] = t23;
        $[17] = t24;
        $[18] = t25;
        $[19] = t26;
        $[20] = t27;
        $[21] = t28;
        $[22] = t29;
        $[23] = t3;
        $[24] = t30;
        $[25] = t31;
        $[26] = t32;
        $[27] = t33;
        $[28] = t34;
        $[29] = t4;
        $[30] = t5;
        $[31] = t6;
        $[32] = t7;
        $[33] = t8;
        $[34] = t9;
    } else {
        t0 = $[0];
        t1 = $[1];
        t10 = $[2];
        t11 = $[3];
        t12 = $[4];
        t13 = $[5];
        t14 = $[6];
        t15 = $[7];
        t16 = $[8];
        t17 = $[9];
        t18 = $[10];
        t19 = $[11];
        t2 = $[12];
        t20 = $[13];
        t21 = $[14];
        t22 = $[15];
        t23 = $[16];
        t24 = $[17];
        t25 = $[18];
        t26 = $[19];
        t27 = $[20];
        t28 = $[21];
        t29 = $[22];
        t3 = $[23];
        t30 = $[24];
        t31 = $[25];
        t32 = $[26];
        t33 = $[27];
        t34 = $[28];
        t4 = $[29];
        t5 = $[30];
        t6 = $[31];
        t7 = $[32];
        t8 = $[33];
        t9 = $[34];
    }
    let t35;
    if ($[35] !== props) {
        t35 = /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({}, props), {
            viewBox: "0 0 120 98",
            width: "120",
            height: "98",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19,
                t20,
                t21,
                t22,
                t23,
                t24,
                t25,
                t26,
                t27,
                t28,
                t29,
                t30,
                t31,
                t32,
                t33,
                t34
            ]
        }));
        $[35] = props;
        $[36] = t35;
    } else t35 = $[36];
    return t35;
};
export { DnDMoveSidebarSettingsImage };
